/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class OpportunityListModel extends JSONable {
  uuid: string | undefined = undefined;
  opportunityName: string | undefined = undefined;
  opportunityType: string | undefined = undefined;
  pipelineStage: string | undefined = undefined;
  expectedCloseDate: Date | undefined = undefined;
  reasonWonLost: string | undefined = undefined;
  leadSource: string | undefined = undefined;
  reasonForLead: string | undefined = undefined;
  probability: number | undefined = undefined;
  customerName: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  territory: string | undefined = undefined;
  sales: string | undefined = undefined;
  contractSigned: boolean | undefined = undefined;
  owner: string | undefined = undefined;
  opportunityPotentialGP: number | undefined = undefined;
  opportunityPotentialRevenue: number | undefined = undefined;
  revenuePerShipment: number | undefined = undefined;
  grossProfitPerShipment: number | undefined = undefined;
  numberOfShipments: number | undefined = undefined;
}
